import React from 'react'
import classes from "../style/JobFinderPage.module.css";
import JobFinder from '../JobFinder';
import RightSidebar from '../../../../common/RightSidebar';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import { Helmet } from 'react-helmet';
import JobSearch from '../JobSearch';

const VolunteerJob = () => {
  return (
    <div className={classes.page}>
      <Helmet>
                <title>Volunteer Jobs</title>
                <meta name="description" content="Find rewarding volunteer job openings in various fields. Contribute to meaningful causes and start making an impact today!" />
        </Helmet>
    <div className={classes.container}>
        <h1 className={classes.title}>Volunteer Job Finder</h1>
        <p className={classes.subTitle}>Explore Volunteer Job Opportunities and Make a Difference</p>
      <JobFinder jobTitle={"Volunteer"}/>
      <JobSearch/>

      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>

      <div className={classes.contentContainer}>
      </div>
    </div>
    <div className={classes.rightsidebar}>
      <RightSidebar/>
    </div>
    </div>
  )
}

export default VolunteerJob;
